module.exports = __webpack_public_path__ + "media/images/writer/home/home-02-518228e4a05c44d36be9bf0dfb986057.png";